<template>
    <div class="item" @click="_onPressToNavigate('传承师信息', 'masterUserDetail', {user_id: item.id, user_type})">
        <img :src="item.inheritor_cover" alt="">
        <div>
            <p>
                <span class="title">{{item.inheritor_name||''}}</span>
                <span class="subtitle">{{item.master_level_text ||''}}</span>
            </p>
            <p class="desc">{{item.inheritor_introduce||''}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "homeInheritorItem",
    props:['item', 'user_type'],
    data() {
        return {
            
        };
    },
    methods: {

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },
    },
};
</script>
<style lang="less" scoped>
.item {
    position: relative;
    margin-top: 22px;
    height: 74px;
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 0px 4px 0px rgba(136,136,136,0.28); 

    > img {
        position: absolute;
        left: 10px;
        bottom: 10px;
        width: 79px;
        height: 76px;
        object-fit: cover;
        margin-right: 10px;
        border-radius: 0.5rem;
    }

    > div {
        margin-left: 89px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > p {
            color: #333;
            line-height: 2;
            font-size: 14px;
            font-weight: 500;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            .subtitle {
                margin-left: 10px;
                font-size: 12px;
                color: #7181EB;
            }
        }

        .desc {
            color: #666;
            font-size: 12px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
}
</style>